import { render, staticRenderFns } from "./postfriends.vue?vue&type=template&id=1e1bbf12&"
import script from "./postfriends.vue?vue&type=script&lang=js&"
export * from "./postfriends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports